module.exports = __webpack_public_path__ + "static/media/freshworks.2e291f51.svg";